import { SVGAProps } from '@/interface'
import { SVGProps } from 'react'

export const BeezerIcon = ({ width, height, ...props }: SVGProps<SVGSVGElement> & SVGAProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={width}
            height={height}
            {...props}
        >
            <path fill="#f98613" d="M3 33h8v5H3z" />
            <path fill="#f1bc18" d="M14 17h8v5h-8z" />
            <path fill="#ed6630" d="M14 25h8v5h-8z" />
            <path fill="#d64d45" d="M14 33h8v5h-8z" />
            <path fill="#bd3369" d="M25 25h8v5h-8z" />
            <path fill="#6d2f87" d="M25 33h8v5h-8z" />
            <path fill="#19aa5c" d="M36 9h8v5h-8z" />
            <path fill="#129b8a" d="M36 17h8v5h-8z" />
            <path fill="#1084b6" d="M36 25h8v5h-8z" />
            <path fill="#1168cf" d="M36 33h8v5h-8z" />
        </svg>

    )
}
